import gql from "graphql-tag";
import { useApolloGqlMutation } from "frontend/hooks/useApolloGql/useApolloGqlMutation.js";
import { messaging } from "frontend/components/fort/mod/photos/constants.js";

// GQL
// If Moderator edits photo shoot title, they are also approving it
const UPDATE_AND_APPROVE_PHOTO_SHOOT_TITLE = gql`
    mutation editPhotoShoot($photoShootId: ID!, $title: String) {
        editPhotoShoot(photoShootId: $photoShootId, title: $title) {
            ok
            errors
            photoShoot {
                id
                title
                titleApproved
            }
        }
        approvePhotoShootTitle(photoShootId: $photoShootId) {
            errors
            ok
            photoShoot {
                id
                title
                titleApproved
            }
        }
    }
`;

const errorHandler = normalizedResp => {
    const { message, errors, actionDesc, gqlVariables } = normalizedResp;
    const { title } = gqlVariables;
    let newMessage = message;

    errors.forEach(em => {
        if (em.includes("1062")) {
            newMessage = `Sorry, we were unable to ${actionDesc}. The contributor has another photo shoot with the same title "${title}". Please choose another title and try again.`;
        }
        if (
            em.includes(
                "Shoot name contains disallowed terms. Please try a different name."
            )
        ) {
            newMessage = messaging.errors.containsDisallowedTerms(
                "photo shoot title"
            );
        }
    });

    return {
        ...normalizedResp,
        message: newMessage
    };
};

export const useUpdateAndApprovePhotoShootTitle = () => {
    return useApolloGqlMutation({
        actionDesc: "Update and Approve Photo Shoot",
        gql: UPDATE_AND_APPROVE_PHOTO_SHOOT_TITLE,
        errorHandler
    });
};
